import styled from 'styled-components';

export const PropagationTag = styled.span`
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #fff;
  background-color: #0000000a;
  color: #00000073;
  font-size: 12px;
  line-height: 16px;
`;
